import { Component } from "@angular/core";
import { NavController } from "@ionic/angular";

@Component({
    selector: "app-facility-search",
    templateUrl: "./facility-search.page.html",
    styleUrls: ["./facility-search.page.scss"]
})
export class FacilitySearchPage {
    constructor(private navCtrl: NavController) {}

    async searchByText(): Promise<void> {
        await this.navCtrl.navigateForward("/contacts/new-contact/facility-search-by-text");
    }

    async selectJurisdiction(jurisdiction: number): Promise<void> {
        await this.navCtrl.navigateForward("/contacts/new-contact/facility-search-by-jurisdiction", {
            queryParams: { jurisdiction }
        });
    }
}
